import React from 'react';
import { Container } from '../ui/Container';
export function Footer() {
  return <footer className="py-8 bg-dark-900 border-t border-dark-700" data-id="element-318">
      <Container data-id="element-319">
        <div className="text-center text-sm text-gray-400" data-id="element-320">
          © {new Date().getFullYear()} GetDealFlow.ai. All rights reserved.
        </div>
      </Container>
    </footer>;
}